<template>
  <v-container fluid>
    <v-card>
      <v-card-text>
        <v-row dense id="po" class="text--primary subtitle-2">
          <v-col cols="12" md="12">
            <v-btn text @click="generateInvoice" color="primary">
              <v-icon color="black" left>mdi-file-pdf-box</v-icon> View
              Invoice
            </v-btn>
          </v-col>
          <v-col cols="12" xs="12" md="4" sm="4">
            <span>Customer: {{ record.ocrd && record.ocrd.Name }}</span><br>
            Order No: {{ record.DocNum }}<br>
            Date: {{ record.DocDate }}
          </v-col>

          <v-col cols="6" v-if="docCreate == true && copyStatus == false">
            <v-autocomplete
              dense
              outlined
              v-model="selectedProduct"
              :items="products"
              label="Search Product To Add To List"
              item-text="product.Name"
              item-value="id"
              @change="setOrderItem"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" id="docForm">
            <v-alert
              v-if="orderItems.length == 0 && docCreate == true"
              type="warning"
              >You have not added any Item.</v-alert
            >

            <v-data-table
              light
              :mobile-breakpoint="0"
              :items-per-page="pageItems"
              :headers="headers"
              :items="orderItems"
              item-key="id"
              hide-default-footer
              @item-selected="selectedRow"
              v-model="selectedItems"
            >
              <template v-slot:item.Name="{ item }">{{ item.Name }}</template>

              <!-- <template v-slot:item.ref1="{ item }">{{item.ref1}}</template> -->

              <template v-slot:item.Quantity="{ item }">{{
                item.Quantity
              }}</template>

              <template v-slot:item.Price="{ item }">
                <span v-if="item.Price">{{ item.Price.toLocaleString() }}</span>
              </template>

              <template v-slot:item.DiscSum="{ item }">{{
                item.DiscSum
              }}</template>

              <template v-slot:item.DisplayTotal="{ item }">{{
                item.DisplayTotal
              }}</template>
            </v-data-table>
          </v-col>

         
        </v-row>

        <v-row>
          <v-divider></v-divider>
        </v-row>

        <v-row>
          <v-col cols="6">
            <v-row dense class="text--primary subtitle-2">
              <v-col cols="12">
                <span v-if="record.DocTotal >= 0"
                  >Total: {{ record.DocTotal.toLocaleString() }}</span
                >
              </v-col>

              <v-col cols="12">
                <span v-if="record.PaidSum >= 0"
                  >Paid: {{ record.PaidSum.toLocaleString() }}</span
                >
              </v-col>

              <v-col cols="12">
                <span v-if="record.Balance >= 0"
                  >Balance: {{ record.Balance.toLocaleString() }}</span
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-btn
              v-if="docCreate == true"
              color="accent"
              @click="sendData"
              :loading="$store.state.btnLoader"
            >
              <v-icon left>mdi-content-save</v-icon>Save
            </v-btn>
          </v-col>
        </v-row>
        <!-- snackbar -->
        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>

    <!-- pdf preview -->
    <pdf-preview ref="pdfPreview"></pdf-preview>
    <!-- end -->
  </v-container>
</template>


<script>
import { generatePdf } from "@/common/pdfMethods.js";
import { http } from "@/common/index";
export default {
  props: {
    initial: {
      type: Object,
      required: true,
    },
    outsourcedData: {
      type: Array,
      required: true,
    },
    docCreate: {
      type: Boolean,
    },
    copyStatus: {
      type: Boolean,
    },
  },
  data: () => ({
    record: {},
    loader: false,
    pageItems: 100,
    selectedProduct: null,
    SumApplied: 0,
    DocNum: null,
    selectedItems: [],
    activeRow: null,
    storeId: null,
    currentCustomerBalance: null,
    genSettings: {},
    companyDetails: {},
    smsRef: null,
    singleSelect: true,
    orderItems: [],
    customers: [],
    products: [],
    stores: [],
    date: new Date().toISOString().substr(0, 10),
    headers: [
      { text: "Product", value: "Name" },
      // { text: "Ref No./ IMEI", value: "ref1" },
      { text: "Qty", value: "Quantity" },
      { text: "Price", value: "Price" },
      { text: "Total", value: "DisplayTotal" },
      // { text: "Action", value: "action" },
    ],
    outHeaders: [
      { text: "Product", value: "Name" },
      { text: "Qty", value: "Quantity" },
      { text: "Price", value: "SellingPrice" },
      { text: "Discount", value: "DiscSum" },
      { text: "Total", value: "LineTotal" },
    ],
  }),
  computed: {
    storeName() {
      return localStorage.getItem("storeName");
    },
    totalAmount() {
      let total = 0;
      if (typeof this.orderItems != "undefined" && this.orderItems.length > 0) {
        return this.orderItems
          .map((item) => {
            const amount = item.LineTotal;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    DiscOnTotal() {
      let disc = 0;
      if (this.record.DiscSum) {
        disc = this.record.DiscSum.toLocaleString();
      }
      return disc;
    },
    totalBefDisc() {
      let total = 0;
      if (this.record.DocTotalBfDisc) {
        total = this.record.DocTotalBfDisc.toLocaleString();
      }
      return total;
    },
    displayBalance() {
      let balance = 0;
      if (this.record.Balance) {
        balance = this.record.Balance.toLocaleString();
      }
      return balance;
    },
    totalPaidAmount() {
      let total = 0;
      if (this.record.PaidSum) {
        total = this.record.PaidSum.toLocaleString();
      }
      return total;
    },
    totalDisplayAmount() {
      let total = 0;
      if (this.record.DocTotal) {
        total = this.record.DocTotal.toLocaleString();
      }
      return total;
    },
  },
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    generatePdf,
    generateReceipt() {
      const rows = this.orderItems;
      const self = this;
      const dataRecord = {
        record: self.record,
        tableData: rows,
      };
      let pdfDoc = this.generatePdf(
        self.storeName,
        self.companyDetails,
        14,
        "Receipt",
        dataRecord
      );

      this.$refs.pdfPreview.show(pdfDoc);
    },
    generateInvoice() {
      const rows = this.orderItems;
      const self = this;
      const dataRecord = {
        record: self.record,
        tableData: rows,
      };
      let pdfDoc = this.generatePdf(
        self.storeName,
        self.companyDetails,
        14,
        "Sale Invoice",
        dataRecord
      );

      this.$refs.pdfPreview.show(pdfDoc);
    },
    generateDelivery() {
      const rows = this.orderItems;
      const self = this;
      const dataRecord = {
        record: self.record,
        tableData: rows,
      };
      let pdfDoc = this.generatePdf(
        self.storeName,
        self.companyDetails,
        14,
        "Delivery",
        dataRecord
      );

      this.$refs.pdfPreview.show(pdfDoc);
    },
    init(val) {
      this.record = { ...val };
      const products = [];
      if (val.rows) {
        for (const row of val.rows) {
          row.Name = row.product.Name;
          row.DisplayTotal = row.LineTotal.toLocaleString();
          products.push(row);
        }
        this.orderItems = products;
      }

      this.getCustomerBalance(val.ocrd.id);
    },
    setDate(date) {
      this.record.DocDate = date;
    },
    reprintReceipt() {
      this.reprintReceiptUbuntu();
      this.reprintWindowsReceipt();
    },
    reprintReceiptUbuntu() {
      let printerUrl = "http://localhost:3000/print";
      //let pr = "https://posprinter.local/print";
      let data = this.record;

      const p_products = data.rows;
      const total_cost = data.DocTotal;
      const total_payments = data.PaidSum;
      const userName = data.seller.name;
      const customerName = data.ocrd.Name;
      const customerBalance = data.Balance;
      const receipt_no = data.DocNum;
      const DiscSum = 0;
      const totalAfterDisc = data.DocTotal;
      const ref2 = data.ocrd.Name;
      const seller = data.seller.name;
      const ChangeAmount = 0;
      const AmountGiven = this.PaidSum;
      const deliveryAddress = data.deliveryAddress;
      const deliveryCustomer = data.ocrd.Name;
      const deliveryPhone = data.ocrd.PhoneNumber;
      const totalDelivery = 200;

      const outstandingBalance = this.currentCustomerBalance;

      return http.post(printerUrl, {
        p_products,
        total_cost,
        DiscSum,
        totalAfterDisc,
        total_payments,
        userName,
        customerName,
        customerBalance,
        receipt_no,
        ref2,
        seller,
        ChangeAmount,
        AmountGiven,
        deliveryAddress,
        deliveryCustomer,
        deliveryPhone,
        totalDelivery,
        outstandingBalance,
      });
    },
    reprintWindowsReceipt() {
      const data = this.record;
      const p_products = data.rows;
      const total_cost = data.DocTotal;
      const total_payments = data.PaidSum;
      const userName = data.seller.name;
      const customerName = data.ocrd.Name;
      const customerBalance = data.Balance;
      const receipt_no = data.DocNum;
      const DiscSum = 0;
      const totalAfterDisc = data.DocTotal;
      const ref2 = data.ocrd.Name;
      const seller = data.seller.name;
      const ChangeAmount = 0;
      const AmountGiven = this.PaidSum;
      const deliveryAddress = data.deliveryAddress;
      const deliveryCustomer = data.ocrd.Name;
      const deliveryPhone = data.ocrd.PhoneNumber;
      const totalDelivery = 0;
      const DocDate = data.DocDate;
      const storeName = this.storeName;

      const outstandingBalance = this.currentCustomerBalance;
      // some updates here

      return http.post(
        "http://localhost/stalispos-receipt/src/transactions/PrintPosReceipt.php",
        {
          p_products,
          total_cost,
          DiscSum,
          totalAfterDisc,
          total_payments,
          userName,
          customerName,
          customerBalance,
          receipt_no,
          ref2,
          seller,
          ChangeAmount,
          AmountGiven,
          deliveryAddress,
          deliveryCustomer,
          deliveryPhone,
          totalDelivery,
          outstandingBalance,
          storeName,
          DocDate,
        }
      );
    },
    printInvoice() {
      let printerUrl = "http://localhost:3000/print/invoice";
      //let pr = "https://posprinter.local/print";
      let data = this.record;

      const p_products = data.rows;
      const total_cost = data.DocTotal;
      const total_payments = data.PaidSum;
      const userName = data.seller.name;
      const customerName = data.ocrd.Name;
      const customerBalance = data.Balance;
      const receipt_no = data.DocNum;
      const DiscSum = 0;
      const totalAfterDisc = data.DocTotal;
      const ref2 = data.ocrd.Name;
      const seller = data.seller.name;
      const ChangeAmount = 0;
      const AmountGiven = this.PaidSum;
      const deliveryAddress = data.deliveryAddress;
      const deliveryCustomer = data.ocrd.Name;
      const deliveryPhone = data.ocrd.PhoneNumber;
      const totalDelivery = 200;

      return http.post(printerUrl, {
        p_products,
        total_cost,
        DiscSum,
        totalAfterDisc,
        total_payments,
        userName,
        customerName,
        customerBalance,
        receipt_no,
        ref2,
        seller,
        ChangeAmount,
        AmountGiven,
        deliveryAddress,
        deliveryCustomer,
        deliveryPhone,
        totalDelivery,
      });
    },
    deleteRow() {
      if (this.activeRow == null) {
        this.$refs.snackbar.show("Please select the item to delete", "red");
      } else {
        const id = this.activeRow;
        const selectedRow = this.orderItems.find((record) => {
          return record.o_i_t_m_s_id === id;
        });
        const pos = this.orderItems.indexOf(selectedRow);
        if (pos === -1) {
          return;
        }
        this.orderItems.splice(pos, 1);
        this.activeRow = null;
        this.selectedItems = [];
      }
    },
    selectedRow($event) {
      this.activeRow = $event.item.o_i_t_m_s_id;
    },
    inputChanged(data) {
      let Price;
      let Quantity;
      if (data.Price) {
        Price = parseFloat(data.Price);
      } else {
        Price = 0;
      }
      if (data.Quantity) {
        Quantity = parseFloat(data.Quantity);
      } else {
        Quantity = 0;
      }
      const LineTotal = Price * Quantity;
      const DisplayTotal = LineTotal.toLocaleString();
      // find item
      const currentItem = this.orderItems.find((record) => {
        return record.o_i_t_m_s_id === data.o_i_t_m_s_id;
      });

      const pos = this.orderItems.indexOf(currentItem);
      if (pos === -1) {
        return;
      }
      // end of find

      // update record
      currentItem.LineTotal = LineTotal;
      currentItem.DisplayTotal = DisplayTotal;
      this.orderItems[pos] = currentItem;
    },
    setOrderItem() {
      if (this.storeId == null) {
        this.$refs.snackbar.show(
          "Please select store or set ita as default on general settings!",
          "red"
        );
      } else {
        const itm2Id = this.selectedProduct;
        const itm2 = this.products.find((record) => {
          return record.id == itm2Id;
        });
        const LineNum = this.orderItems.length + 1;
        const store_id = this.storeId;
        // check if the product exist
        const orderProduct = this.orderItems.find((record) => {
          return record.o_i_t_m_s_id === itm2.product.id;
        });
        if (orderProduct) {
          this.$refs.snackbar.show(
            "That product already exist on the List",
            "red"
          );
        } else {
          const orderItem = {
            LineNum: LineNum,
            o_i_t_m_s_id: itm2.product.id,
            store_id: store_id,
            Name: itm2.product.Name,
            Quantity: null,
            Price: null,
            LineTotal: 0,
            DisplayTotal: 0,
          };
          this.orderItems.push(orderItem);
        }
        // end of check
        this.selectedProduct = "";
      }
    },
    sendData() {
      if (this.orderItems.length > 0) {
        const balance = this.totalAmount - this.SumApplied;
        if (balance > 0 && this.record.CardCode == undefined) {
          this.$refs.snackbar.show("Please select customer", "red");
        } else {
          const data = this.record;
          data.rows = this.orderItems;
          data.TargetType = null;
          data.BaseType = null;
          data.BaseEntry = null;
          data.ObjType = 14;
          data.DocTotal = this.totalAmount;
          data.DocNum = this.DocNum;
          // set payments
          let payments = [];
          const paidAmount = this.SumApplied;
          let paymentData = { o_a_c_t_s_id: 1, SumApplied: paidAmount };
          payments.push(paymentData);
          data.payments = payments;
          // end
          this.$store.commit("btnLoader", true);
          this.$emit("data", data);
        }
      } else {
        this.$refs.snackbar.show("You must have at least one product", "red");
      }
    },
    getCustomers() {
      const self = this;
      this.$store
        .dispatch("get", `/customers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.customers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    productsInit(id) {
      const self = this;
      this.$store
        .dispatch("get", `/stores/${id}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.products = res.ResponseData.itm2;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getProducts() {
      const self = this;
      //  get store id first
      this.$store
        .dispatch("get", `/general-settings`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.productsInit(res.ResponseData.store_id);
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
      // end
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGenSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.genSettings = res.ResponseData;
            self.smsRef = res.ResponseData.smsRef;
            if (res.ResponseData.DefaultStockStore) {
              self.storeId = res.ResponseData.DefaultStockStore;
              self.smsRef = res.ResponseData.smsRef;
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getCompanyDetails() {
      const self = this;
      this.$store
        .dispatch("get", `/company-details`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.companyDetails = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getDocNum() {
      const self = this;
      this.$store
        .dispatch("get", `/document-numbering/14`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.DocNum = res.ResponseData.NextNumber;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getCustomerBalance(id) {
      const self = this;
      this.$store
        .dispatch("get", `/get-customer-balance/${id}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.currentCustomerBalance = res.ResponseData.Balance;
          } else {
            self.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getCustomers();
    this.getCompanyDetails();
    this.getStores();
    this.getGenSettings();
    this.getDocNum();
  },
};
</script>

<style  scoped>
/* .v-text-field__details {
  display: none !important;
} */
</style>